import angular from 'angular';
import uiRouter from 'angular-ui-router';

let adpSelectizeModule = angular.module('adpSelectize', [
  uiRouter
])
.directive('adpSelectize', function() {
  function link(scope, element, attrs) {
    $(element[0]).selectize(scope.options);
  }
  return {
    restrict: 'AE',
    scope: {
      options: '='
    },
    link: link,
  };
})

.name;

export default adpSelectizeModule;



// WEBPACK FOOTER //
// ./src/app/components/adpTypeahead/adpSelectize.js